import type { MouseEvent } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@monksflow/monks-ui';

interface BriefTemplateConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  cancelLabel: string;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/** For the row actions that reach beyond one workspace: promoting, and a system-wide turn-off. */
export function BriefTemplateConfirmDialog(props: BriefTemplateConfirmDialogProps) {
  return (
    <AlertDialog
      open={props.open}
      onOpenChange={(open: boolean) => {
        if (!open && !props.isPending) props.onCancel();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{props.title}</AlertDialogTitle>
          <AlertDialogDescription>{props.description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={props.isPending}>{props.cancelLabel}</AlertDialogCancel>
          <AlertDialogAction
            disabled={props.isPending}
            onClick={(event: MouseEvent<HTMLButtonElement>) => {
              // Stays open until the request lands, so a failure keeps the choice on screen.
              event.preventDefault();
              props.onConfirm();
            }}
          >
            {props.confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
